import * as Tone from 'tone';

/**
 * Calculate one beat duration in seconds from time signature
 * (takes into account if the base is 4th note, 8th note etc
 * so for example in 7/8 it calculates 8th note duration)
 * @param {number[]} timeSignature
 * @returns {number} seconds per beat
 */
export function get1BeatDurationInSeconds(timeSignature: number[]): number {
	if (window == null) {
		console.warn('window is not defined');
		return 0;
	}
	const noteLength = 4 / timeSignature[1]; // calculate 4th note 8th note etc
	const bpm = Tone.Transport.bpm.value;
	return (60 / bpm) * noteLength;
}
